
import {Component, Vue} from 'vue-property-decorator'
import {clearSearchHistory, getSearchHistoryList, SearchHistoryDto} from "@/api/shoppingMall"
import {Getter} from "vuex-class";
import SearchNav from "@/components/SearchNav/index.vue";

@Component({
  components: {SearchNav}
})
export default class searchCommodity extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string
  private historyList: Array<SearchHistoryDto> = []
  searchType = '' // 1：店铺搜索 2：店铺商品搜索 3:商品搜索
  searchValue = ''

  show=true
  loading = false
  finished = false

  created(){
    this.searchType=this.$route.query.searchType as string
    this.getHistoryList()
  }
  /**
   * 获取历史搜索记录
   */
  getHistoryList() {
    let params = {
      searchType: this.searchType, // 1：店铺搜索2：店铺商品搜索 3:商品搜索
      providerId: this.companyId
    }
    getSearchHistoryList(params).then(res => {
      this.historyList = res.data
    })
  }

  toSearchShop(keyword: string) {
    console.log(123456)
   if (this.searchType === '3') {
      this.$router.replace({
        path: '/searchCooms',
        query: {
          keyword: keyword
        }
      })
    }

  }

  clearFunc() {
    let params = {
      searchType: this.searchType, // 1：店铺搜索2：店铺商品搜索  3:商品搜索
      providerId: this.companyId
    }
    clearSearchHistory(params).then(() => {
      this.$toast({message: '已清除'})
      this.getHistoryList()
    }).catch(() => {})
  }

  //取消
  onCancel(){
    //location.reload()
    this.$router.go(0)
  }




  // toDetail() {
  //
  //   this.$router.push('/customerDetail')
  // }



}
